import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { BulkGrantResponse } from '@/repositories/generated';

const response: BulkGrantResponse[] = [
  {
    id: '001',
    systemName: 'モック一括付与1',
  },
  {
    id: '002',
    systemName: 'モック一括付与2',
  },
  {
    id: '003',
    systemName: 'モック一括付与3',
  },
];

export const autocompleteBulkGrant = http.get(
  createMockEndpoint('/autocomplete/bulk_grant'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
